import { PropsWithChildren } from 'react';
import styles from './Badge.module.scss';
import { Caption, Text } from '@components';
import { BADGE_SIZE } from '@types';

type BadgeProps = {
	text: string;
	backgroundColor?: string;
	size?: BADGE_SIZE;
	position?: 'top-left' | 'top-right';
}

export const Badge = (props:PropsWithChildren<BadgeProps>) => {
	const {
		children,
		text,
		backgroundColor,
		size = BADGE_SIZE.LARGE,
		position
	} = props;
	return (
		<div className={`${styles.container} ${size === BADGE_SIZE.EXTRA_LARGE && styles.containerXL}`}>
			<div
				data-testid='@Ofload-Badge'
				className={`
					${styles.badge} 
					${size === BADGE_SIZE.EXTRA_LARGE && styles.badgeXL}
					${position && styles[position]}
				`}
				style={{ backgroundColor: backgroundColor }}
			>
				{
					size === BADGE_SIZE.LARGE ?
						<Caption text={text} color={'var(--neutral-00)'} /> :
						<Text text={text} color={'var(--neutral-00)'} />
				}
			</div>
			{children}
		</div>
	);
}
